import React from 'react';
import ReactDOM from 'react-dom/client';

import '@fontsource-variable/inter';

import App from './app/App';

import './index.scss';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <>
        <App />
    </>
);
